import { Observable } from "rxjs";

export const chunkArray = (arr: any[], size = 3): any[][] => {
  const result: any[][] = [];

  for (let i = 0; i < arr.length; i += size) {
    result.push(arr.slice(i, i + size));
  }

  return result;
};

export const compareDate = (
  target: Date | string,
): 'high' | 'warning' | null => {
  const today = new Date();
  const targetDate = new Date(target);

  today.setHours(0, 0, 0, 0);
  targetDate.setHours(0, 0, 0, 0);

  if (today > targetDate) return 'high';
  if (today.getDate() === targetDate.getDate() &&
      today.getMonth() === targetDate.getMonth() &&
      today.getFullYear() === targetDate.getFullYear()) return 'warning';

  return null;
};

export const blobToBase64 = (blob: Blob): Observable<string> => {
  return new Observable<string>((observer) => {
    const reader = new FileReader();

    reader.onloadend = () => {
      observer.next(reader.result as string);
      observer.complete();
    };

    reader.onerror = (err) => observer.error(err);

    reader.readAsDataURL(blob);

    return () => reader.abort();
  });
};

export const getFirstAndLastInitial = (str: string): string => {
  if (!str) return '';

  const words = str.trim().split(/\s+/);

  if (words.length === 1) {
    return words[0][0].toUpperCase();
  }

  return (
    words[0][0] + words[words.length - 1][0]
  ).toUpperCase();
}

export const getFontSize = (width: number, dpr: number = 1, ratio: number = 0.0043) => {
  const minFont = 0;
  const maxFont = 17;

  const dprFactor = dpr > 1 ? 1 / Math.sqrt(dpr) : 1;

  const size = width * ratio;

  return Math.min(Math.max(size, minFont), maxFont);
}

export const getRemainingDaysByDate = (target: string): number => {
  const today = new Date();
  const targetDate = new Date(target);

  const startOfToday = new Date(
    today.getFullYear(),
    today.getMonth(),
    today.getDate()
  );

  const startOfTarget = new Date(
    targetDate.getFullYear(),
    targetDate.getMonth(),
    targetDate.getDate()
  );

  const diffMs = startOfTarget.getTime() - startOfToday.getTime();
  const diffDays = diffMs / (1000 * 60 * 60 * 24);

  return Math.ceil(diffDays);
}
